// extracted by mini-css-extract-plugin
module.exports = {"sidebarPaper":"styles_sidebarPaper__2TxEG","dataItem":"styles_dataItem__2C7H_"};